import { Component } from 'react';

export class EditSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M1.64645 8.04645L1.5 8.19289V8.4V10V10.5H2H3.6H3.80711L3.95355 10.3536L9.95355 4.35355L10.3071 4L9.95355 3.64645L8.35355 2.04645L8 1.69289L7.64645 2.04645L1.64645 8.04645ZM4 11.5H1C0.813624 11.5 0.697164 11.4401 0.628553 11.3714C0.559943 11.3028 0.5 11.1864 0.5 11V8C0.5 7.90834 0.514686 7.85431 0.531906 7.81557C0.550091 7.77465 0.58307 7.72404 0.653553 7.65355L7.65355 0.653553C7.85829 0.448816 8.14171 0.448816 8.34645 0.653553L11.3464 3.65355C11.5512 3.85829 11.5512 4.14171 11.3464 4.34645L4.34645 11.3464C4.27596 11.4169 4.22535 11.4499 4.18443 11.4681C4.14569 11.4853 4.09166 11.5 4 11.5Z" />
                <path d="M0.5 14.5H15.5V15.5H0.5V14.5Z" />
            </svg>
        );
    }
}
